export default __webpack_public_path__ + "static/media/newks.d5f2f29c.png";